import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getDynamicSectionById } from '../../services'
import { DynamicSectionQueryKeys } from '@/modules/client-setting/keys'
import { GetDynamicSectionByIdResponse } from '@/modules/client-setting/type'

export default function useQueryGetDynamicSectionById(
	id: string,
	props?: UseBaseQueryOptions<GetDynamicSectionByIdResponse>,
) {
	return useQuery({
		queryKey: [DynamicSectionQueryKeys.GetDynamicSectionById, id],
		queryFn: () => getDynamicSectionById(id),
		...props,
	})
}
